import { Divider, Grid, Skeleton, Typography } from "@mui/material";

import { useDeviceType } from "../../hooks/useDeviceType";
import React from "react";

const LabeledItem = ({
  label,
  value,
  isLoading = false,
  withDivider = true,
}: {
  label: string;
  value?: React.ReactNode;
  isLoading?: boolean;
  withDivider?: boolean;
}) => {
  const { isMobile } = useDeviceType();
  return (
    <>
      <Grid item xs={12} md={4}>
        <Typography
          sx={{
            px: {
              xs: 2,
              md: 0,
            },
          }}
          align={isMobile ? "left" : "right"}
          variant="subtitle2"
        >
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        {isLoading || value === undefined ? (
          <Skeleton variant="text" width={"80%"} />
        ) : (
          <>
            {React.isValidElement(value) ? (
              <>{value}</>
            ) : (
              <Typography
                sx={{
                  px: {
                    xs: 2,
                    md: 0,
                  },
                  wordBreak: "break-word",
                  whiteSpace: "pre-line",
                }}
                variant="body2"
              >
                {value}
              </Typography>
            )}
          </>
        )}
      </Grid>
      {withDivider && (
        <Grid item xs={12}>
          <Divider />
        </Grid>
      )}
    </>
  );
};

export default LabeledItem;
